export default __webpack_public_path__ + "static/media/no-mosquito.1da4dcbb.png";